import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from 'vnetwork-ui'
import CheckIcons from '@/icons/CheckIcons'

interface ActionButtonsProps {
    onSubmit: () => void
    isPending: boolean
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
    onSubmit,
    isPending,
}) => {
    const { t } = useTranslation()

    return (
        <div
            className="flex flex-col md:flex-row-reverse gap-2"
            data-tour="submit-btn"
        >
            <Button
                id="ticket_create"
                variant="contained"
                size="small"
                type="submit"
                onClick={onSubmit}
                loading={isPending}
                disabled={isPending}
                startIcon={<CheckIcons />}
                className="w-full"
            >
                {t('ticket-create')}
            </Button>
            <Link to="/tickets" className="w-full">
                <Button
                    variant="outlined"
                    size="small"
                    loading={isPending}
                    disabled={isPending}
                    className="w-full"
                >
                    {t('cancle-operation')}
                </Button>
            </Link>
        </div>
    )
}

export default ActionButtons
